import { useContext } from 'react';

import { AgGridReact } from 'ag-grid-react';

import { WithLocalStorage } from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';
import { PrimaryContext } from '@/services';
import type { ShipmentRecipient } from '@/services/shipping/types';
import { useContextMenu } from '@/utils/context-menu';

import { recipientColumnDefs } from '../../utils/columnDefs';

type ShipmentRecipientGridProps = {
  recipients: ShipmentRecipient[] | null | undefined;
};

export const ShipmentRecipientGrid = ({
  recipients,
}: ShipmentRecipientGridProps) => {
  const defaultGridOptions = useDefaultGridOptions();
  const { themeMode } = useContext(PrimaryContext);
  const { getContextMenuItems } = useContextMenu({ idKey: 'id' });

  return (
    <div className="shipment__grid ag-grid-height-300">
      <WithLocalStorage storageKey="shipment-recipient-grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${themeMode === 'dark' ? '-dark' : ''}`}
          defaultColDef={defaultColDef}
          rowData={recipients}
          columnDefs={recipientColumnDefs}
          getContextMenuItems={getContextMenuItems}
        />
      </WithLocalStorage>
    </div>
  );
};
